<template>
    
        <AltNavigationBar/>
<div class="container-account">
      <div class="content m-3" >
         

        <div class="col">
<img class="logo" src="../assets/tangerine-logo.svg" alt="...">

            <div class="form-container row">
            <div class="col-12 my-3 start-col">
             
                <LoginForm @submit="handleSubmit" :isLogin="false"/>
            </div>
            
            </div>
            </div>
        
        </div>
    </div>
    <AltFooterView/>
    
</template>

<script>
import LoginForm from '@/components/LoginForm.vue';
import AltNavigationBar from '@/components/AltNavigationBar.vue';
import AltFooterView from '@/components/AltFooter.vue';
import { auth } from '../../src/firebase.js';
import { createUserWithEmailAndPassword } from 'firebase/auth';

export default{
    name: "CreateAccount",
components: {
    LoginForm,
    AltFooterView,
    AltNavigationBar
  },
  methods:{
    handleSubmit(email,password,firstName,lastName){
        console.log(`${email} ${password} ${firstName} ${lastName}`)
        createUserWithEmailAndPassword(auth, email, password)
  .then((userCredential) => {
    console.log('User signed up:', userCredential.user);
  })
  .catch((error) => {
    console.error(error);
  });
    }
  }
}
</script>

<style>
.container-account{
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  height: 100%; /* or 100vh if it's the viewport */
}
.content{
     
  flex: 1; /* takes all available space */
}
.form-container{
    margin-left: auto;
  margin-right: auto;
}
.logo{
  width: 35%;
  height: 35%;
}
</style>